var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Check, Close, Download, ExpandMore, MoreVert, Search } from '@mui/icons-material';
import { Chip, useMediaQuery } from '@mui/material';
import moment from 'moment';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { v4 } from 'uuid';
import { ReactComponent as LeftArrow } from '../../../assets/images/arrow-left.svg';
import { ReactComponent as EditIcon } from '../../../assets/images/edit-icon.svg';
import { ReactComponent as LinkSvg } from '../../../assets/images/linkIcon.svg';
import { ReactComponent as ShareIcon } from '../../../assets/images/shearIcon.svg';
import { getLoadingKey, getUpdateKey } from '../../../builderPackage/common/commonFunctions';
import { DynamicFormBuilderContainer } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container';
import { FormItemTypes } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity';
import { LOCAL_STORAGE_KEYS } from '../../../constants';
import { showSurface } from '../../../redux/awaitedSurfacesSlice';
import { getListAPI, setReducerState } from '../../../redux/crudSlice';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { secondary } from '../../../theme/colors';
import { getStatusColor } from '../../../theme/statusColors';
import { getLocalStorageItem } from '../../../utils/storageHelper';
import { dateFormate } from '../../../utils/utils';
import { CSODiscard } from '../../contractSaleOrder/components/discard';
import { PrintIconSVG } from '../../spareParts/purchaseRequistion/assets/customIcons';
import InspectionQuestionGroup from '../components/InspectionQuestionGroup';
import InspectionQuestionGroupMobileView from '../components/inspectionQuestionGroupMobileView';
import { PDICheckSavedSuccessfullpopup } from '../components/PDICheckSavedSuccessfullpopup';
import RoadTestMap from '../components/roadTestMap';
import { getAllPDICheckAPI, SearchPDICheckAPI, ServiceAdvisorAPI, TechnicianListAPI, UploadAttachmentPDICheckAPICall } from '../services/apiCalls';
import { PDICheckKeys, PDICheckMandatoryFields, pdiCheckUpsertsUrl, preCheckQuestionsUrl } from '../services/entity';
import { showNotification } from '../../../redux/commonSlice';
var CreateNewPDICheck = function () {
    var _getLocalStorageItem, _getLocalStorageItem2, _getLocalStorageItem3, _getLocalStorageItem4, _crud$PDICheckKeys$Vi, _crud$PDICheckKeys$In, _crud$PDICheckKeys$Vi2, _crud$PDICheckKeys$Co, _crud$PDICheckKeys$In2, _crud$PDICheckKeys$Vi4, _crud$PDICheckKeys$In3, _searchType$, _crud$PDICheckKeys$Se, _crud$PDICheckKeys$Se2, _crud$PDICheckKeys$Co3;
    var id = useParams().id;
    console.log("id", id);
    var IS_MOBILE = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var IS_DESKTOP = useMediaQuery(function (theme) { return theme.breakpoints.up("sm"); });
    var IS_TAB = useMediaQuery(function (theme) { return theme.breakpoints.down("md"); });
    var dispatch = useAppDispatch();
    var navigate = useNavigate();
    var crud = useAppSelector(function (state) { return state.crud; });
    var organizationId = (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH)) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.OrganizationId;
    var parentOrganizationId = (_getLocalStorageItem2 = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH)) === null || _getLocalStorageItem2 === void 0 ? void 0 : _getLocalStorageItem2.ParentOrganizationId;
    var UserOrganization = (_getLocalStorageItem3 = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem3 === void 0 || (_getLocalStorageItem3 = _getLocalStorageItem3.data) === null || _getLocalStorageItem3 === void 0 || (_getLocalStorageItem3 = _getLocalStorageItem3.Branches[0]) === null || _getLocalStorageItem3 === void 0 ? void 0 : _getLocalStorageItem3.OrganizationId;
    var IdentityId = (_getLocalStorageItem4 = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem4 === void 0 || (_getLocalStorageItem4 = _getLocalStorageItem4.data) === null || _getLocalStorageItem4 === void 0 ? void 0 : _getLocalStorageItem4.IdentityId;
    var _a = useState(null), roadTestData = _a[0], setRoadTestData = _a[1];
    var _b = useState(), inspectionStatus = _b[0], setInspectionStatus = _b[1];
    // const handleDataUpdate = (data: any) => {
    //   console.log('Received in Parent:', data);
    //   setRoadTestData(data);
    // };
    var shouldShowQuestions = id ? ((_crud$PDICheckKeys$Vi = crud[PDICheckKeys === null || PDICheckKeys === void 0 ? void 0 : PDICheckKeys.ViewPDICheck]) === null || _crud$PDICheckKeys$Vi === void 0 || (_crud$PDICheckKeys$Vi = _crud$PDICheckKeys$Vi.data) === null || _crud$PDICheckKeys$Vi === void 0 || (_crud$PDICheckKeys$Vi = _crud$PDICheckKeys$Vi.PreDeliveryDetail) === null || _crud$PDICheckKeys$Vi === void 0 ? void 0 : _crud$PDICheckKeys$Vi.length) > 0 : ((_crud$PDICheckKeys$In = crud[PDICheckKeys === null || PDICheckKeys === void 0 ? void 0 : PDICheckKeys.InpectionQuestionPDICheck]) === null || _crud$PDICheckKeys$In === void 0 || (_crud$PDICheckKeys$In = _crud$PDICheckKeys$In.data) === null || _crud$PDICheckKeys$In === void 0 ? void 0 : _crud$PDICheckKeys$In.length) > 0;
    var shouldShowTrue = function (data) {
        var _data$PreDeliveryDeta, _data$PreDeliveryDeta2;
        return (_data$PreDeliveryDeta = data === null || data === void 0 || (_data$PreDeliveryDeta2 = data.PreDeliveryDetail) === null || _data$PreDeliveryDeta2 === void 0 ? void 0 : _data$PreDeliveryDeta2.some(function (detail) {
            var _detail$Questions;
            return detail === null || detail === void 0 || (_detail$Questions = detail.Questions) === null || _detail$Questions === void 0 ? void 0 : _detail$Questions.some(function (question) { return (question === null || question === void 0 ? void 0 : question.InspectionResult) === 2; });
        })) !== null && _data$PreDeliveryDeta !== void 0 ? _data$PreDeliveryDeta : false;
    };
    var inspectionResultPassOrFail = shouldShowTrue((_crud$PDICheckKeys$Vi2 = crud[PDICheckKeys === null || PDICheckKeys === void 0 ? void 0 : PDICheckKeys.ViewPDICheck]) === null || _crud$PDICheckKeys$Vi2 === void 0 ? void 0 : _crud$PDICheckKeys$Vi2.data);
    var dynamicValues = crud === null || crud === void 0 || (_crud$PDICheckKeys$Co = crud[PDICheckKeys === null || PDICheckKeys === void 0 ? void 0 : PDICheckKeys.ConfigurationPDICheck]) === null || _crud$PDICheckKeys$Co === void 0 || (_crud$PDICheckKeys$Co = _crud$PDICheckKeys$Co.data) === null || _crud$PDICheckKeys$Co === void 0 || (_crud$PDICheckKeys$Co = _crud$PDICheckKeys$Co.DynamicValues) === null || _crud$PDICheckKeys$Co === void 0 ? void 0 : _crud$PDICheckKeys$Co[0];
    var employeeConfig = (dynamicValues === null || dynamicValues === void 0 ? void 0 : dynamicValues.EmployeeConfiguration) || [];
    var complaintConfig = (dynamicValues === null || dynamicValues === void 0 ? void 0 : dynamicValues.ComplaintConfiguration) || [];
    var getSelectValuesByName = function (name) {
        var item = employeeConfig.find(function (entry) { return (entry === null || entry === void 0 ? void 0 : entry.DisplayName) === name; });
        return item || [];
    };
    var serviceAdvisorRequired = getSelectValuesByName("Service Advisor");
    var technicianRequired = getSelectValuesByName("Technician");
    var getComplaintConfigValuesByName = function (name) {
        var item = complaintConfig.find(function (entry) {
            var _entry$ComplaintTypeI;
            return (entry === null || entry === void 0 || (_entry$ComplaintTypeI = entry.ComplaintTypeId) === null || _entry$ComplaintTypeI === void 0 ? void 0 : _entry$ComplaintTypeI.Value) === name;
        });
        return item || [];
    };
    var customerComplaint = getComplaintConfigValuesByName("1");
    var observation = getComplaintConfigValuesByName("2");
    var defectCategory = getComplaintConfigValuesByName("5");
    var actionTaken = getComplaintConfigValuesByName("3");
    var isLoading = [crud[getLoadingKey(PDICheckKeys === null || PDICheckKeys === void 0 ? void 0 : PDICheckKeys.UpsertPDICheck)]].includes('loading');
    var handleDataUpdate = function (data) {
        console.log('Received in Parent:', data);
        setRoadTestData(data);
    };
    console.log('crud-----', (_crud$PDICheckKeys$In2 = crud[PDICheckKeys === null || PDICheckKeys === void 0 ? void 0 : PDICheckKeys.InpectionQuestionPDICheck]) === null || _crud$PDICheckKeys$In2 === void 0 ? void 0 : _crud$PDICheckKeys$In2.data);
    var QuestionGroupElements = [{
            type: FormItemTypes.Custom,
            name: 'Questions',
            columnSize: 12,
            // validator(values, state) {
            //   let error: GridErrorState | undefined = undefined;
            //   console.log('values--PDI--', values)
            //   console.log('state--PDI--', state)
            //   values?.find((r: ResponseObject) => {
            //     const errorField = Object.keys(PDICheckMandatoryFields)?.find(field => {
            //       const value = r[field];
            //       const isEmpty = value === undefined || value === null || value.toString().trim() === '';
            //       const isNotNumberOrBoolean = typeof value !== 'number' && typeof value !== 'boolean';
            //       if (field === 'Remarks') {
            //         return r?.InspectionResult === 2 && isEmpty;
            //       }
            //       // if (field === 'CustomerVoiceName') {
            //       //   const hasInspectionCriteria = r?.InspectionCriteria != null;
            //       //   console.log('CustomerVoiceName validation:', {
            //       //     hasInspectionCriteria,
            //       //     value: r[field],
            //       //     isEmpty,
            //       //   });
            //       //   return hasInspectionCriteria && isEmpty;
            //       // }
            //       if (field === 'CustomerVoiceName') {
            //         const isMandatory = customerComplaint?.IsMandatory === true;
            //         const isEmpty = value === undefined || value === null || value.toString().trim() === '';
            //         return isMandatory && isEmpty;
            //       }
            //       if (field === 'ObservationId') {
            //         const isMandatory = observation?.IsMandatory === true;
            //         const isEmpty = value === undefined || value === null || value.toString().trim() === '';
            //         return isMandatory && isEmpty;
            //       }
            //       if (field === 'DefectCategoryId') {
            //         const isMandatory = defectCategory?.IsMandatory === true;
            //         const isEmpty = value === undefined || value === null || value.toString().trim() === '';
            //         return isMandatory && isEmpty;
            //       }
            //       if (field === 'ActionTakenId') {
            //         const isMandatory = actionTaken?.IsMandatory === true;
            //         const isEmpty = value === undefined || value === null || value.toString().trim() === '';
            //         return isMandatory && isEmpty;
            //       }
            //       return isEmpty && isNotNumberOrBoolean;
            //     });
            //     if (errorField) {
            //       // const shouldValidateActionTaken = id && errorField === 'ActionTakenId';
            //       // const shouldValidateOtherFields = errorField !== 'ActionTakenId';
            //       // if (shouldValidateActionTaken || shouldValidateOtherFields) {
            //       error = {
            //         id: v4(),
            //         rowId: r.id,
            //         field: PDICheckMandatoryFields[errorField],
            //         message: 'This field is required',
            //         value: r[errorField]
            //       // };
            //       }
            //     }
            //     // if (errorField) {
            //     //   error = {
            //     //     id: v4(),
            //     //     rowId: r.id,
            //     //     field: PDICheckMandatoryFields[errorField],
            //     //     message: 'This field is required',
            //     //     value: r[errorField]
            //     //   };
            //     // }
            //     return Boolean(errorField);
            //   });
            //   return error;
            // },
            validator: function (values, state) {
                var error = undefined;
                values === null || values === void 0 || values.find(function (r) {
                    var _Object$keys;
                    var errorField = (_Object$keys = Object.keys(PDICheckMandatoryFields)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.find(function (field) {
                        var value = r[field];
                        var isEmpty = value === undefined || value === null || value.toString().trim() === '';
                        var isNotNumberOrBoolean = typeof value !== 'number' && typeof value !== 'boolean';
                        if (field === 'Remarks') {
                            return (r === null || r === void 0 ? void 0 : r.InspectionResult) === 2 && isEmpty;
                        }
                        if (field === 'CustomerVoiceName') {
                            var isMandatory = (customerComplaint === null || customerComplaint === void 0 ? void 0 : customerComplaint.IsMandatory) === true;
                            var isPassMandatory = isMandatory && (r === null || r === void 0 ? void 0 : r.InspectionResult) === 1 && (customerComplaint === null || customerComplaint === void 0 ? void 0 : customerComplaint.InspectionStatus) === 'Pass';
                            var isFailMandatory = isMandatory && (r === null || r === void 0 ? void 0 : r.InspectionResult) === 2 && (customerComplaint === null || customerComplaint === void 0 ? void 0 : customerComplaint.InspectionStatus) === 'Fail';
                            var isBothMandatory = isMandatory && (customerComplaint === null || customerComplaint === void 0 ? void 0 : customerComplaint.InspectionStatus) === 'Both';
                            return (isPassMandatory || isFailMandatory || isBothMandatory) && isEmpty;
                        }
                        if (field === 'ObservationId') {
                            var isMandatory = (observation === null || observation === void 0 ? void 0 : observation.IsMandatory) === true;
                            var isPassMandatory = isMandatory && (r === null || r === void 0 ? void 0 : r.InspectionResult) === 1 && (observation === null || observation === void 0 ? void 0 : observation.InspectionStatus) === 'Pass';
                            var isFailMandatory = isMandatory && (r === null || r === void 0 ? void 0 : r.InspectionResult) === 2 && (observation === null || observation === void 0 ? void 0 : observation.InspectionStatus) === 'Fail';
                            var isBothMandatory = isMandatory && (observation === null || observation === void 0 ? void 0 : observation.InspectionStatus) === 'Both';
                            console.log('isFailMandatory:', isFailMandatory);
                            return (isPassMandatory || isFailMandatory || isBothMandatory) && isEmpty;
                        }
                        if (field === 'DefectCategoryId') {
                            var isMandatory = (defectCategory === null || defectCategory === void 0 ? void 0 : defectCategory.IsMandatory) === true;
                            var isPassMandatory = isMandatory && (r === null || r === void 0 ? void 0 : r.InspectionResult) === 1 && (defectCategory === null || defectCategory === void 0 ? void 0 : defectCategory.InspectionStatus) === 'Pass';
                            var isFailMandatory = isMandatory && (r === null || r === void 0 ? void 0 : r.InspectionResult) === 2 && (defectCategory === null || defectCategory === void 0 ? void 0 : defectCategory.InspectionStatus) === 'Fail';
                            var isBothMandatory = isMandatory && (defectCategory === null || defectCategory === void 0 ? void 0 : defectCategory.InspectionStatus) === 'Both';
                            console.log('isFailMandatory:', isFailMandatory);
                            return (isPassMandatory || isFailMandatory || isBothMandatory) && isEmpty;
                        }
                        if (field === 'ActionTakenId') {
                            var isMandatory = (actionTaken === null || actionTaken === void 0 ? void 0 : actionTaken.IsMandatory) === true;
                            var isPassMandatory = isMandatory && (r === null || r === void 0 ? void 0 : r.InspectionResult) === 1 && (actionTaken === null || actionTaken === void 0 ? void 0 : actionTaken.InspectionStatus) === 'Pass';
                            var isFailMandatory = isMandatory && (r === null || r === void 0 ? void 0 : r.InspectionResult) === 2 && (actionTaken === null || actionTaken === void 0 ? void 0 : actionTaken.InspectionStatus) === 'Fail';
                            var isBothMandatory = isMandatory && (actionTaken === null || actionTaken === void 0 ? void 0 : actionTaken.InspectionStatus) === 'Both';
                            var hasId = id;
                            // const hasId = id && r?.InspectionResult === 2;
                            return (isPassMandatory || isFailMandatory || isBothMandatory || hasId) && isEmpty;
                        }
                        return isEmpty && isNotNumberOrBoolean;
                    });
                    if (errorField) {
                        var IsRemarks = errorField === "Remarks";
                        error = {
                            id: v4(),
                            rowId: r.id,
                            field: PDICheckMandatoryFields[errorField],
                            message: IsRemarks ? 'Remark is mandatory when the inspection result is Failed' : 'This Field is required',
                            value: r[errorField]
                        };
                    }
                    return Boolean(errorField);
                });
                return error;
            },
            element: InspectionQuestionGroup
        }];
    var InspectionTab = [{
            type: FormItemTypes.ContainerItem,
            name: '',
            label: '',
            value: null,
            columnSize: 12,
            spacing: 0,
            gap: 1,
            elements: [{
                    type: FormItemTypes.Typography,
                    name: 'QuestionGroupName',
                    label: '',
                    valueGetter: function (formValues, field) {
                        var currValue = formValues === null || formValues === void 0 ? void 0 : formValues[this.name];
                        if (currValue)
                            return currValue;
                        else
                            return '-';
                    },
                    value: null,
                    columnSize: 0,
                    fontSize: 'base',
                    fontWeight: 'medium'
                }, {
                    type: FormItemTypes.Chip,
                    name: '',
                    label: inspectionStatus !== null && inspectionStatus !== void 0 ? inspectionStatus : 0,
                    color: 'primary',
                    columnSize: true,
                    setFieldProps: function (formValues, currValue, field) {
                        var _formValues$Questions;
                        var questionCount = formValues === null || formValues === void 0 || (_formValues$Questions = formValues.Questions) === null || _formValues$Questions === void 0 ? void 0 : _formValues$Questions.length;
                        return {
                            type: FormItemTypes.Chip,
                            label: questionCount
                        };
                    }
                    // setFormState(formValues, currValue, field) {
                    //   console.log('PDICheckKeys-', formValues)
                    //   const questionCount = formValues?.Questions?.length;
                    //   console.log("Number of questions:", questionCount);
                    //   setInspectionStatus(questionCount)
                    //   return {}
                    // },
                }, {
                    type: FormItemTypes.IconButton,
                    name: '',
                    label: '',
                    children: /*#__PURE__*/ React.createElement(ExpandMore, null),
                    setFormState: function (Formvalues) { return __awaiter(void 0, void 0, void 0, function () {
                        var res;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, dispatch(showSurface({
                                        type: 'Drawer',
                                        Component: InspectionQuestionGroupMobileView,
                                        containerProps: {
                                            PaperProps: {
                                                sx: {
                                                    width: {
                                                        xs: '100%',
                                                        sm: '100%',
                                                        borderRadius: '12px'
                                                    }
                                                }
                                            },
                                            anchor: 'bottom'
                                        },
                                        componentProps: {
                                            data: Formvalues
                                        }
                                    }))];
                                case 1:
                                    res = _a.sent();
                                    // const originalQuestions = Formvalues?.Questions;
                                    // const updatedQuestions = res?.payload?.Questions;
                                    // const mergedQuestions = originalQuestions?.map((question: any) => {
                                    //   const updated = updatedQuestions?.find((q: any) => q.id === question.id);
                                    //   return updated ? { ...question, ...updated } : question;
                                    // });
                                    // const mergedResponse = {
                                    //   ...Formvalues,
                                    //   Questions: mergedQuestions,
                                    // };
                                    // console.log('mergedResponse', mergedResponse);
                                    return [2 /*return*/, res === null || res === void 0 ? void 0 : res.payload];
                            }
                        });
                    }); },
                    columnSize: 0
                }]
        }];
    var GENERAL_TAB = [{
            type: FormItemTypes.CardComponent,
            name: '',
            columnSize: 12,
            label: 'Basic details',
            sx: {
                fontSize: 'base',
                fontWeight: 'strong'
            },
            elements: [{
                    type: FormItemTypes.SearchSelect,
                    name: 'InspectorId',
                    label: 'Service advisor',
                    getListData: ServiceAdvisorAPI,
                    disabled: id ? true : false,
                    apiRequest: {
                        BranchId: organizationId
                    },
                    apiKey: PDICheckKeys.PDICheckServiceAdvisor,
                    getOptionLabel: function (option) { return (option === null || option === void 0 ? void 0 : option.GivenName) + " " + (option === null || option === void 0 ? void 0 : option.FamilyName); },
                    displayExpr: 'GivenName',
                    valueExpr: 'UserId',
                    required: Boolean(serviceAdvisorRequired === null || serviceAdvisorRequired === void 0 ? void 0 : serviceAdvisorRequired.IsMandatory),
                    validator: function (value, state) {
                        if (Boolean(serviceAdvisorRequired === null || serviceAdvisorRequired === void 0 ? void 0 : serviceAdvisorRequired.IsMandatory) === true && (value === null || value === '' || value === undefined)) {
                            return 'Service Advisor selection is mandatory';
                        }
                        return undefined;
                    }
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'TechnicianId',
                    label: 'Technician',
                    getListData: TechnicianListAPI,
                    disabled: id ? true : false,
                    apiRequest: {
                        WorkingOrganizationId: UserOrganization
                    },
                    getOptionLabel: function (option) { return (option === null || option === void 0 ? void 0 : option.FirstName) + " " + (option === null || option === void 0 ? void 0 : option.LastName); },
                    valueExpr: 'id',
                    required: Boolean(technicianRequired === null || technicianRequired === void 0 ? void 0 : technicianRequired.IsMandatory),
                    validator: function (value, state) {
                        if (Boolean(technicianRequired === null || technicianRequired === void 0 ? void 0 : technicianRequired.IsMandatory) === true && (value === null || value === '' || value === undefined)) {
                            return 'Technician selection is mandatory';
                        }
                        return undefined;
                    }
                }, {
                    type: FormItemTypes.NumberInput,
                    name: 'OdometerReading',
                    label: 'Odometer',
                    disabled: id ? true : false,
                    required: true,
                    validator: function (value, state) {
                        var _state$DynamicValues;
                        var limit = state === null || state === void 0 || (_state$DynamicValues = state.DynamicValues) === null || _state$DynamicValues === void 0 || (_state$DynamicValues = _state$DynamicValues[0]) === null || _state$DynamicValues === void 0 ? void 0 : _state$DynamicValues.OdometerReadingLimit;
                        var numericValue = Number(value);
                        if (value === null || value === '' || value === undefined) {
                            return 'Please enter the odometer reading.';
                        }
                        if (!/^\d+$/.test(value)) {
                            return 'Enter a valid whole number';
                        }
                        if (!Number.isInteger(numericValue)) {
                            return 'Odometer must be a whole number';
                        }
                        if (limit !== undefined && numericValue > limit) {
                            return "Odometer reading exceeds the ".concat(limit, ". Please enter a valid odometer reading.");
                        }
                        return undefined;
                    }
                },
                // {
                //   type: FormItemTypes.NumberInput,
                //   name: 'OdometerReading',
                //   label: 'Odometer',
                //   disabled: id ? true : false,
                //   required: true,
                //   valueGetter: (val: any, row: any) => { console.log('val--99--', val?.PreDeliveryDetail?.Questions?.InspectionResult), (crud[PDICheckKeys?.ViewPDICheck]?.data?.InspectionResult === 1 ? 'Pass' : crud[PDICheckKeys?.ViewPDICheck]?.data?.InspectionResult === 2 ? 'Fail' : '') },
                //   setFormState: (formValues, currValue) => {
                //     return {
                //       OdometerReading: formValues?.OdometerReading,
                //     }
                //   },
                //   validator: (value, state) => {
                //     const limit = state?.DynamicValues?.[0]?.OdometerReadingLimit;
                //     const numericValue = Number(value);
                //     if (!Number.isInteger(numericValue)) {
                //       return 'Odometer must be a whole number';
                //     }
                //     if (limit !== undefined && numericValue > limit) {
                //       return `Odometer reading exceeds the ${limit}. Please enter a valid odometer reading.`;
                //     }
                //     if(value === null) {
                //       return 'Please enter the odometer reading.';
                //     }
                //     if (!/^\d+$/.test(value)) {
                //       return 'Enter a valid number';
                //     }
                //     return undefined;
                //   }
                // },
                {
                    type: FormItemTypes.TextInput,
                    name: '',
                    label: 'Inspection status',
                    placeholder: '',
                    disabled: true,
                    valueGetter: function (val, row) {
                        var _crud$PDICheckKeys$Vi3;
                        var result = crud === null || crud === void 0 || (_crud$PDICheckKeys$Vi3 = crud[PDICheckKeys === null || PDICheckKeys === void 0 ? void 0 : PDICheckKeys.ViewPDICheck]) === null || _crud$PDICheckKeys$Vi3 === void 0 || (_crud$PDICheckKeys$Vi3 = _crud$PDICheckKeys$Vi3.data) === null || _crud$PDICheckKeys$Vi3 === void 0 ? void 0 : _crud$PDICheckKeys$Vi3.InspectionResult;
                        var InspectionSelectionStatus = function () {
                            var _val$PreDeliveryDetai, _val$PreDeliveryDetai2;
                            var hasFail = val === null || val === void 0 || (_val$PreDeliveryDetai = val.PreDeliveryDetail) === null || _val$PreDeliveryDetai === void 0 ? void 0 : _val$PreDeliveryDetai.some(function (detail) {
                                var _detail$Questions2;
                                return detail === null || detail === void 0 || (_detail$Questions2 = detail.Questions) === null || _detail$Questions2 === void 0 ? void 0 : _detail$Questions2.some(function (question) { return (question === null || question === void 0 ? void 0 : question.InspectionResult) === 2; });
                            });
                            if (hasFail)
                                return 'Fail';
                            var hasPass = val === null || val === void 0 || (_val$PreDeliveryDetai2 = val.PreDeliveryDetail) === null || _val$PreDeliveryDetai2 === void 0 ? void 0 : _val$PreDeliveryDetai2.some(function (detail) {
                                var _detail$Questions3;
                                return detail === null || detail === void 0 || (_detail$Questions3 = detail.Questions) === null || _detail$Questions3 === void 0 ? void 0 : _detail$Questions3.some(function (question) { return (question === null || question === void 0 ? void 0 : question.InspectionResult) === 1; });
                            });
                            if (hasPass)
                                return 'Pass';
                            return undefined;
                        };
                        var resultPassOrFail = InspectionSelectionStatus();
                        return result === 1 ? 'Pass' : result === 2 ? 'Fail' : resultPassOrFail || '';
                    }
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: "taskDetails",
            label: "",
            value: null,
            columnSize: 8,
            xs: 12,
            setFieldProps: function (formValues, currValue) {
                var _formValues$DynamicVa;
                return {
                    type: this.type,
                    sx: {
                        display: formValues !== null && formValues !== void 0 && (_formValues$DynamicVa = formValues.DynamicValues) !== null && _formValues$DynamicVa !== void 0 && (_formValues$DynamicVa = _formValues$DynamicVa[0]) !== null && _formValues$DynamicVa !== void 0 && _formValues$DynamicVa.IsRoadTestMandatoryForPDI ? 'flex' : 'none'
                    }
                };
            },
            // setFieldProps: (formValues, currValue) => (
            //   console.log('Road Test -- ', formValues?.DynamicValues?.[0]?.IsRoadTestMandatoryForPDI),
            //   {
            //     type: this.type,
            //     display: formValues?.DynamicValues?.[0]?.IsRoadTestMandatoryForPDI ? true : true
            //   }
            // ),
            elements: [IS_TAB ? {
                    type: FormItemTypes.Accordian,
                    name: "roadTest",
                    label: "",
                    value: null,
                    summary: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            label: '',
                            value: null,
                            children: 'Road test',
                            columnSize: 0,
                            fontSize: 'base',
                            fontWeight: 'strong'
                        }],
                    elements: [{
                            type: FormItemTypes.ContainerItem,
                            name: "",
                            spacing: 0,
                            columnSize: 12,
                            elements: [{
                                    type: FormItemTypes.Divider,
                                    name: '',
                                    variant: 'fullWidth',
                                    columnSize: 12
                                }, {
                                    type: FormItemTypes.ContainerItem,
                                    name: '',
                                    columnSize: 12,
                                    spacing: 0,
                                    elements: [{
                                            type: FormItemTypes.Custom,
                                            name: 'RoadTestComponent',
                                            columnSize: 12,
                                            disabled: false,
                                            element: function (props) {
                                                var _props$value, _props$value2, _props$value3, _props$value4, _props$value5, _props$value6, _props$value7, _props$value8, _props$value9;
                                                var distance = (props === null || props === void 0 || (_props$value = props.value) === null || _props$value === void 0 ? void 0 : _props$value.RoadTest) && (props === null || props === void 0 || (_props$value2 = props.value) === null || _props$value2 === void 0 || (_props$value2 = _props$value2.RoadTest[0]) === null || _props$value2 === void 0 ? void 0 : _props$value2.Distance);
                                                var startdate = (props === null || props === void 0 || (_props$value3 = props.value) === null || _props$value3 === void 0 ? void 0 : _props$value3.RoadTest) && moment(props === null || props === void 0 || (_props$value4 = props.value) === null || _props$value4 === void 0 || (_props$value4 = _props$value4.RoadTest[0]) === null || _props$value4 === void 0 ? void 0 : _props$value4.StartDateTime);
                                                var enddate = (props === null || props === void 0 || (_props$value5 = props.value) === null || _props$value5 === void 0 ? void 0 : _props$value5.RoadTest) && moment(props === null || props === void 0 || (_props$value6 = props.value) === null || _props$value6 === void 0 || (_props$value6 = _props$value6.RoadTest[0]) === null || _props$value6 === void 0 ? void 0 : _props$value6.EndDateTime);
                                                var duration = (props === null || props === void 0 || (_props$value7 = props.value) === null || _props$value7 === void 0 ? void 0 : _props$value7.RoadTest) && moment.duration(enddate.diff(startdate)).asSeconds();
                                                return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(RoadTestMap, {
                                                    timeDuration: duration,
                                                    coveredDistance: distance
                                                    // isTestDone={isTestDone}
                                                    ,
                                                    pathCordinates: (props === null || props === void 0 || (_props$value8 = props.value) === null || _props$value8 === void 0 ? void 0 : _props$value8.RoadTest) && (props === null || props === void 0 || (_props$value9 = props.value) === null || _props$value9 === void 0 || (_props$value9 = _props$value9.RoadTest[0]) === null || _props$value9 === void 0 ? void 0 : _props$value9.GeoCoordination)
                                                    // onStartTest={handleStartRoadTest}
                                                    // onClickEndTest={handleEndRoadTest}
                                                    // onClickRoadTestTraslate={(value: boolean) => setTranslateToJobChecked(value)}
                                                    // onClickRoadTestVehicleDetails={(value: boolean) => setOpenViewJobs(value)}
                                                    ,
                                                    isviewOnly: false
                                                    // onClickMsgIcon={handleMessageIcon}
                                                    ,
                                                    isDisabled: false,
                                                    onDataUpdate: handleDataUpdate
                                                }));
                                            }
                                        }]
                                }]
                        }],
                    columnSize: 12
                } : null]
        }];
    var INSPECTION = [shouldShowQuestions ? IS_DESKTOP ? {
            type: FormItemTypes.CardComponent,
            name: '',
            columnSize: 12,
            sx: {
                borderRadius: '12px',
                padding: 0
            },
            contentProps: {
                spacing: 0
            },
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    spacing: 0,
                    padding: '8px 12px',
                    columnGap: '20px',
                    alignItems: 'center',
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            children: 'Inspection',
                            columnSize: true,
                            fontSize: 'base',
                            fontWeight: 'strong'
                        }, {
                            type: FormItemTypes.Button,
                            name: 'PassBtn',
                            variant: 'outlined',
                            children: 'Pass all',
                            color: 'success',
                            columnSize: 0,
                            startIcon: /*#__PURE__*/ React.createElement(Check, null),
                            setFormState: function (formValues, currValue, field) {
                                var _formValues$PreDelive;
                                console.log('formvalues 312', formValues === null || formValues === void 0 ? void 0 : formValues.PreDeliveryDetail);
                                if (id) {
                                    return;
                                }
                                var updatedQuestionGroups = formValues === null || formValues === void 0 || (_formValues$PreDelive = formValues.PreDeliveryDetail) === null || _formValues$PreDelive === void 0 ? void 0 : _formValues$PreDelive.map(function (group) {
                                    var _group$Questions;
                                    return _objectSpread(_objectSpread({}, group), {}, {
                                        Questions: (_group$Questions = group.Questions) === null || _group$Questions === void 0 ? void 0 : _group$Questions.map(function (question) { return _objectSpread(_objectSpread({}, question), {}, {
                                            InspectionResult: 1
                                        }); })
                                    });
                                });
                                var allPassed = updatedQuestionGroups === null || updatedQuestionGroups === void 0 ? void 0 : updatedQuestionGroups.every(function (group) {
                                    var _group$Questions2;
                                    return (_group$Questions2 = group.Questions) === null || _group$Questions2 === void 0 ? void 0 : _group$Questions2.every(function (question) { return (question === null || question === void 0 ? void 0 : question.InspectionResult) === 1; });
                                });
                                console.log('updatedFormValues', updatedQuestionGroups);
                                return {
                                    PreDeliveryDetail: updatedQuestionGroups,
                                    allPassed: allPassed
                                };
                            },
                            setFieldProps: function (formValues, currValue, field) {
                                var _formValues$PreDelive2;
                                var allPassed = formValues === null || formValues === void 0 || (_formValues$PreDelive2 = formValues.PreDeliveryDetail) === null || _formValues$PreDelive2 === void 0 ? void 0 : _formValues$PreDelive2.every(function (group) {
                                    var _group$Questions3;
                                    return (_group$Questions3 = group.Questions) === null || _group$Questions3 === void 0 ? void 0 : _group$Questions3.every(function (question) { return (question === null || question === void 0 ? void 0 : question.InspectionResult) === 1; });
                                });
                                return {
                                    type: FormItemTypes.Button,
                                    variant: allPassed ? 'contained' : 'outlined'
                                };
                            }
                        }, {
                            type: FormItemTypes.Button,
                            name: 'FailBtn',
                            variant: 'outlined',
                            children: 'Fail all',
                            color: 'error',
                            columnSize: 0,
                            startIcon: /*#__PURE__*/ React.createElement(Close, null),
                            setFormState: function (formValues, currValue, field) {
                                var _formValues$PreDelive3;
                                console.log('formvalues 312', formValues === null || formValues === void 0 ? void 0 : formValues.PreDeliveryDetail);
                                if (id) {
                                    return;
                                }
                                var updatedQuestionGroups = formValues === null || formValues === void 0 || (_formValues$PreDelive3 = formValues.PreDeliveryDetail) === null || _formValues$PreDelive3 === void 0 ? void 0 : _formValues$PreDelive3.map(function (group) {
                                    var _group$Questions4;
                                    return _objectSpread(_objectSpread({}, group), {}, {
                                        Questions: (_group$Questions4 = group.Questions) === null || _group$Questions4 === void 0 ? void 0 : _group$Questions4.map(function (question) { return _objectSpread(_objectSpread({}, question), {}, {
                                            InspectionResult: 2
                                        }); })
                                    });
                                });
                                console.log('updatedFormValues', updatedQuestionGroups);
                                return {
                                    PreDeliveryDetail: updatedQuestionGroups
                                };
                            },
                            setFieldProps: function (formValues, currValue, field) {
                                var _formValues$PreDelive4;
                                var allFailed = formValues === null || formValues === void 0 || (_formValues$PreDelive4 = formValues.PreDeliveryDetail) === null || _formValues$PreDelive4 === void 0 ? void 0 : _formValues$PreDelive4.every(function (group) {
                                    var _group$Questions5;
                                    return (_group$Questions5 = group.Questions) === null || _group$Questions5 === void 0 ? void 0 : _group$Questions5.every(function (question) { return question.InspectionResult === 2; });
                                });
                                return {
                                    type: FormItemTypes.Button,
                                    variant: allFailed ? 'contained' : 'outlined'
                                };
                            }
                        }]
                }, {
                    type: FormItemTypes.Iterator,
                    name: 'PreDeliveryDetail',
                    columnSize: 12,
                    value: null,
                    containerProps: {
                        container: true,
                        spacing: 2
                    },
                    gridItemProps: {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12
                    },
                    elements: QuestionGroupElements
                }]
        } : {
            type: FormItemTypes.CardComponent,
            name: '',
            label: '',
            required: true,
            value: null,
            columnSize: 12,
            elements: [{
                    type: FormItemTypes.Typography,
                    name: '',
                    label: 'Inspection ',
                    children: /*#__PURE__*/ React.createElement(Chip, {
                        color: "primary",
                        label: id ? (_crud$PDICheckKeys$Vi4 = crud[PDICheckKeys === null || PDICheckKeys === void 0 ? void 0 : PDICheckKeys.ViewPDICheck]) === null || _crud$PDICheckKeys$Vi4 === void 0 || (_crud$PDICheckKeys$Vi4 = _crud$PDICheckKeys$Vi4.data) === null || _crud$PDICheckKeys$Vi4 === void 0 || (_crud$PDICheckKeys$Vi4 = _crud$PDICheckKeys$Vi4.PreDeliveryDetail) === null || _crud$PDICheckKeys$Vi4 === void 0 ? void 0 : _crud$PDICheckKeys$Vi4.length : (_crud$PDICheckKeys$In3 = crud[PDICheckKeys === null || PDICheckKeys === void 0 ? void 0 : PDICheckKeys.InpectionQuestionPDICheck]) === null || _crud$PDICheckKeys$In3 === void 0 || (_crud$PDICheckKeys$In3 = _crud$PDICheckKeys$In3.data) === null || _crud$PDICheckKeys$In3 === void 0 ? void 0 : _crud$PDICheckKeys$In3.length
                    }),
                    columnSize: 4,
                    labelTypographyProps: {
                        fontSize: 'base',
                        fontWeight: 'strong',
                        color: 'secondary.900'
                    },
                    containerProps: {
                        display: 'inline-flex',
                        justifyContent: 'space-between'
                    }
                }, {
                    type: FormItemTypes.List,
                    name: 'PreDeliveryDetail',
                    value: null,
                    variant: 'expanded',
                    disableCheckboxSelection: true,
                    disableDetailsPanel: true,
                    getRowHeight: function () { return 'auto'; },
                    columnSize: 12,
                    rowHeight: 48,
                    elements: InspectionTab
                }]
        } : null];
    var ADDITIONAL_INFO = [{
            type: FormItemTypes.CardComponent,
            name: "NotesAndAttachments",
            label: "",
            value: null,
            columnSize: 12,
            variant: "outlined",
            elements: [{
                    type: FormItemTypes.Typography,
                    name: "",
                    children: 'Notes & attachments',
                    columnSize: 12,
                    fontSize: 'base',
                    fontWeight: 'strong'
                }, {
                    type: FormItemTypes.TextInput,
                    name: "Remarks",
                    label: "Additional remarks",
                    value: null,
                    disabled: id ? true : false,
                    labelTypographyProps: {
                        fontSize: "12px",
                        fontWeight: 500
                    },
                    // columnSize: 6,
                    multiline: true,
                    maxLength: 200,
                    minRows: 3,
                    sx: {
                        xs: 12,
                        sm: 6
                    }
                }, {
                    type: FormItemTypes.Attachment,
                    name: "Attachments",
                    label: "Add attachments",
                    placeholder: "Upload Files",
                    disabled: id ? true : false,
                    labelTypographyProps: {
                        fontSize: "12px",
                        fontWeight: 500
                    },
                    setFieldProps: function (formValues, currValue, field) {
                        var MAX_SIZE = 5 * 1024 * 1024;
                        var validFiles = Array !== null && Array !== void 0 && Array.isArray(currValue) ? currValue === null || currValue === void 0 ? void 0 : currValue.filter(function (file) {
                            if ((file === null || file === void 0 ? void 0 : file.size) > MAX_SIZE) {
                                return false;
                            }
                            return true;
                        }) : [];
                        return {
                            type: FormItemTypes.Attachment,
                            value: validFiles
                        };
                    },
                    validator: function (value, state) {
                        var maxSizeInBytes = 5 * 1024 * 1024; // 5MB
                        var invalidFiles = value === null || value === void 0 ? void 0 : value.filter(function (file) {
                            var _file$size;
                            return ((_file$size = file === null || file === void 0 ? void 0 : file.size) !== null && _file$size !== void 0 ? _file$size : file === null || file === void 0 ? void 0 : file.Size) > maxSizeInBytes;
                        });
                        if ((invalidFiles === null || invalidFiles === void 0 ? void 0 : invalidFiles.length) > 0) {
                            return "The file size exceeds 5 MB.";
                        }
                        return "";
                    },
                    value: null,
                    sx: {
                        xs: 12,
                        sm: 6
                    },
                    inputProps: {
                        accept: [".jpeg", ".png", ".xlsx", ".docx", "pdf"]
                    },
                    // inputProps: {
                    //   accept: [".xlsx", '.jpeg', '.docx', '.mp4'],
                    //   multiple: true,
                    // },
                    uploadAttachmentRequest: {
                        systemname: PDICheckKeys === null || PDICheckKeys === void 0 ? void 0 : PDICheckKeys.PDICheckCreateAttachment
                    },
                    uploadAttachmentAPI: UploadAttachmentPDICheckAPICall
                }]
        }];
    var searchType = [{
            id: 'EngineNo',
            label: 'Engine. No'
        }, {
            id: 'VinNo',
            label: 'Vin. No'
        }];
    var formData = [
        // {
        //   type: FormItemTypes.ContainerItem,
        //   name: '',
        //   columnSize: 12,
        //   spacing: 0,
        //   paddingInline: IS_MOBILE ? '16px' : '24px',
        //   pt: '16px',
        //   pb: "20px",
        //   position: 'relative',
        //   gap: '16px',
        //   justifyContent: 'space-between',
        //   elements: [
        //     {
        //       type: FormItemTypes.Box,
        //       name: '',
        //       display: 'flex',
        //       // xs: 6,
        //       // sm: 6,
        //       // md: 6,
        //       // lg: 6,
        //       alignItems: 'center',
        //       gap: '16px',
        //       elements: [
        //         {
        //           type: FormItemTypes.IconButton,
        //           name: '',
        //           children: <LeftArrow />,
        //           sx: {
        //             color: 'secondary.600',
        //           },
        //           columnSize: 0,
        //           onClick: () => { navigate('/pdicheck') }
        //         },
        //         {
        //           type: FormItemTypes.Box,
        //           name: '',
        //           display: 'flex',
        //           columnSize: true,
        //           alignItems: 'center',
        //           sx: {
        //             justifyContent: {
        //               xs: "space-between",
        //               sm: 'start'
        //             }
        //           },
        //           gap: '12px',
        //           elements: [
        //             {
        //               type: FormItemTypes.Box,
        //               name: '',
        //               display: 'flex',
        //               alignItems: 'center',
        //               columnSize: true,
        //               gap: '12px',
        //               // justifyContent: (id && IS_MOBILE) ? 'space-between' : 'start',
        //               elements: [
        //                 {
        //                   type: FormItemTypes.Typography,
        //                   name: '',
        //                   value: 'New PDI check',
        //                   fontWeight: 'strong',
        //                   fontSize: IS_MOBILE ? 'lg' : 'xxl',
        //                   columnSize: 0
        //                 },
        //                 id ?
        //                   {
        //                     type: FormItemTypes.Chip,
        //                     name: 'StatusName',
        //                     columnSize: 0,
        //                     sx: {
        //                       borderRadius: '6px',
        //                       height: '24px',
        //                       fontWeight: 'medium'
        //                     },
        //                     size: 'medium',
        //                     setFieldProps: (state) => (
        //                       console.log('state', state),
        //                       {
        //                         type: FormItemTypes.Chip,
        //                         label: `${state?.Status?.DisplayName ?? ""}`,
        //                         color: getStatusColor(state?.StatusName ?? "").color,
        //                         sx: {
        //                           borderRadius: '6px',
        //                           height: '24px',
        //                           fontWeight: 'medium',
        //                           // display: state?.StatusName ? undefined : 'none'
        //                         }
        //                       }
        //                     )
        //                   } : null,
        //                 // {
        //                 //   type: FormItemTypes.IconButton,
        //                 //   name: "menuIcon",
        //                 //   color: 'secondary',
        //                 //   size: 'small',
        //                 //   children: <MoreVert color='secondary' />,
        //                 //   columnSize: true,
        //                 //   sx: {
        //                 //     width: '18px',
        //                 //     height: '18px',
        //                 //     display:'flex',
        //                 //     justifyContent:'end'
        //                 //   },
        //                 // },
        //               ],
        //             },
        //           ]
        //         }
        //       ]
        //     },
        //     IS_DESKTOP ?{
        //       type: FormItemTypes.Box,
        //       name: '',
        //       label: '',
        //       value: null,
        //       // sm:4,
        //       // md:2.4,
        //       columnSize:6,
        //       display: 'flex',
        //       flex:'end',
        //       elements: [
        //         {
        //           type: FormItemTypes.Typography,
        //           name: 'CreatedOn',
        //           label: 'DOC DATE:',
        //           containerProps: { display: 'inline-flex', alignItems: 'baseline', gap: 1 },
        //           labelTypographyProps: { mb: 0, noWrap: true, fontWeight: 'strong', fontSize: 'sm' },
        //           columnSize: 0,
        //           fontSize: 'base',
        //           fontWeight: 'normal',
        //           valueGetter(formValues, field) {
        //             return dateFormate(id ? formValues?.CreatedOn : new Date());
        //           }
        //         },
        //         {
        //           type: FormItemTypes.IconButton,
        //           name: "menuIcon",
        //           color: 'secondary',
        //           size: 'small',
        //           children: <EditIcon color='secondary' />,
        //           // children: <EditIcon height={3} width={3} color='secondary' />,
        //           columnSize: true,
        //           sx: {
        //             width: '25px',
        //             height: '25px'
        //           },
        //         },
        //         {
        //           type: FormItemTypes.IconButton,
        //           name: "menuIcon",
        //           color: 'secondary',
        //           size: 'small',
        //           children: <MoreVert color='secondary' />,
        //           columnSize: true,
        //           sx: {
        //             width: '18px',
        //             height: '18px'
        //           },
        //         },
        //       ],
        //     }:null,
        //   ]
        // },
        {
            type: FormItemTypes.ContainerItem,
            name: "PageHeader",
            columnSize: 12,
            justifyContent: 'space-between',
            spacing: 0,
            p: 1,
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    xs: 12,
                    sm: 5,
                    md: true,
                    lg: true,
                    spacing: 0,
                    justifyContent: 'space-between',
                    elements: [{
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            label: '',
                            value: null,
                            columnSize: 10,
                            elements: [{
                                    type: FormItemTypes.IconButton,
                                    name: "",
                                    children: /*#__PURE__*/ React.createElement(LeftArrow, null),
                                    sx: {
                                        color: 'secondary.600'
                                    },
                                    columnSize: 0,
                                    onClick: function () {
                                        navigate('/pdicheck');
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: "",
                                    label: "",
                                    children: "New PDI check",
                                    columnSize: 0,
                                    fontSize: "xxl",
                                    fontWeight: "strong"
                                }, id ? {
                                    type: FormItemTypes.Chip,
                                    name: 'StatusName',
                                    columnSize: true,
                                    sx: {
                                        borderRadius: '6px',
                                        height: '24px',
                                        fontWeight: 'medium',
                                        marginLeft: '5px'
                                    },
                                    size: 'medium',
                                    setFieldProps: function (state) {
                                        var _state$Status$Display, _state$Status, _state$StatusName;
                                        return {
                                            type: FormItemTypes.Chip,
                                            label: "".concat((_state$Status$Display = state === null || state === void 0 || (_state$Status = state.Status) === null || _state$Status === void 0 ? void 0 : _state$Status.DisplayName) !== null && _state$Status$Display !== void 0 ? _state$Status$Display : ""),
                                            color: getStatusColor((_state$StatusName = state === null || state === void 0 ? void 0 : state.StatusName) !== null && _state$StatusName !== void 0 ? _state$StatusName : "").color,
                                            sx: {
                                                borderRadius: '6px',
                                                height: '24px',
                                                fontWeight: 'medium',
                                                marginLeft: '5px',
                                                display: state !== null && state !== void 0 && state.StatusName ? undefined : 'none'
                                            }
                                        };
                                    }
                                } : {
                                    type: FormItemTypes.Chip,
                                    name: "Open",
                                    label: "Open",
                                    value: null,
                                    columnSize: true,
                                    color: "primary",
                                    shape: 'rounded',
                                    sx: {
                                        marginTop: '3px',
                                        marginLeft: '5px'
                                    }
                                }]
                        }, !IS_DESKTOP ? {
                            type: FormItemTypes.Button,
                            name: 'More',
                            children: /*#__PURE__*/ React.createElement(MoreVert, null),
                            size: 'small',
                            variant: 'text',
                            color: 'secondary',
                            sx: {
                                p: '7px'
                            },
                            columnSize: 0
                        } : null]
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    xs: 12,
                    sm: true,
                    md: true,
                    lg: true,
                    spacing: 0,
                    item: false,
                    gap: 1,
                    justifyContent: {
                        xs: "space-between",
                        sm: 'end'
                    },
                    alignContent: 'center',
                    elements: IS_DESKTOP ? [{
                            type: FormItemTypes.Typography,
                            name: "CreatedOn",
                            label: "DOC DATE:",
                            valueGetter: function (formValues, field) {
                                return dateFormate(id ? formValues === null || formValues === void 0 ? void 0 : formValues.CreatedOn : new Date());
                            },
                            containerProps: {
                                display: "inline-flex",
                                justifyContent: {
                                    xs: "space-between",
                                    sm: 'end'
                                },
                                alignItems: "baseline",
                                gap: 1
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true
                            },
                            columnSize: 0
                        }, {
                            type: FormItemTypes.IconButton,
                            name: "menuIcon",
                            color: 'secondary',
                            size: 'small',
                            children: /*#__PURE__*/ React.createElement(EditIcon, {
                                color: "secondary"
                            }),
                            columnSize: 0,
                            sx: {
                                width: '25px',
                                height: '25px'
                            }
                        }, {
                            type: FormItemTypes.Button,
                            name: 'More',
                            children: /*#__PURE__*/ React.createElement(MoreVert, null),
                            size: 'small',
                            variant: 'text',
                            color: 'secondary',
                            sx: {
                                p: '0px',
                                alignmentBaseline: 'center'
                            },
                            columnSize: 0
                        }] : [{
                            type: FormItemTypes.Typography,
                            name: "",
                            label: "DOC DATE:",
                            value: '-',
                            valueGetter: function (formValues, field) {
                                try {
                                    if (id && !(formValues !== null && formValues !== void 0 && formValues.CreatedOn))
                                        return "-";
                                    var rawDate = id && formValues !== null && formValues !== void 0 && formValues.CreatedOn ? formValues.CreatedOn : new Date();
                                    var date = new Date(rawDate);
                                    return isNaN(date.getTime()) ? "Invalid Date" : dateFormate(date);
                                }
                                catch (_unused) {
                                    return "Error";
                                }
                            },
                            containerProps: {
                                display: "inline-flex",
                                mx: 1,
                                justifyContent: "space-between",
                                alignItems: "baseline",
                                gap: 1
                            },
                            labelTypographyProps: {
                                mb: 0,
                                mx: 1,
                                noWrap: true,
                                fontSize: 'sm',
                                fontWeight: 'medium'
                            },
                            fontSize: 'sm',
                            fontWeight: 'normal',
                            xs: true
                        }, {
                            type: FormItemTypes.IconButton,
                            name: "menuIcon",
                            color: 'secondary',
                            size: 'small',
                            children: /*#__PURE__*/ React.createElement(EditIcon, {
                                color: "secondary"
                            }),
                            columnSize: 0,
                            sx: {
                                width: '25px',
                                height: '25px'
                            }
                        }]
                }]
        }, {
            type: FormItemTypes.Box,
            name: '',
            height: '68px',
            padding: '16px 24px',
            gap: '12px',
            bgcolor: secondary[100],
            borderTop: '1px solid ',
            borderBottom: '1px solid ',
            borderColor: secondary[200],
            columnSize: 12,
            justifyContent: id ? 'end' : 'space-between',
            display: IS_MOBILE && id ? 'none' : 'flex',
            elements: [{
                    type: FormItemTypes.Stack,
                    name: 'actions',
                    direction: 'row',
                    alignItems: 'center',
                    columnGap: 0.5,
                    borderRadius: 2,
                    px: 1.25,
                    py: 0.5,
                    border: '1px solid',
                    borderColor: 'secondary.300',
                    bgcolor: 'white',
                    width: '100%',
                    maxWidth: 400,
                    sx: {
                        display: id ? 'none' : undefined
                    },
                    elements: [{
                            type: FormItemTypes.SingleSelect,
                            name: 'label',
                            value: (_searchType$ = searchType[0]) === null || _searchType$ === void 0 ? void 0 : _searchType$.id,
                            options: searchType,
                            displayExpr: 'label',
                            variant: 'standard',
                            disableUnderline: true,
                            sx: {
                                minWidth: 90
                            },
                            columnSize: 0,
                            setFormState: function () {
                                return {
                                    Value: '',
                                    TextInput: '',
                                    searchSuccess: false
                                };
                            }
                        }, {
                            type: FormItemTypes.TextInput,
                            name: 'TextInput',
                            columnSize: true,
                            variant: 'standard',
                            placeholder: 'Search by Engine No and Vin No',
                            sx: {},
                            InputProps: {
                                disableUnderline: true
                            },
                            setFormState: function (formValues) {
                                return {
                                    search: false,
                                    searchSuccess: formValues.TextInput === "" || formValues.TextInput === null || formValues.TextInput === undefined ? false : undefined
                                };
                            },
                            valueSetter: function (state, currValue, field) {
                                var _a;
                                return (_a = {},
                                    _a[field.name] = currValue === null || currValue === void 0 ? void 0 : currValue.trim(),
                                    _a);
                            }
                        }, {
                            type: FormItemTypes.IconButton,
                            name: 'searchButton',
                            columnSize: 0,
                            color: 'secondary',
                            children: /*#__PURE__*/ React.createElement(Search, {
                                color: "secondary"
                            }),
                            setFieldProps: function (formValues, currValue, field, formApi) {
                                console.log('filter Log--', formValues);
                                return {
                                    disabled: (formValues === null || formValues === void 0 ? void 0 : formValues.TextInput) == undefined || (formValues === null || formValues === void 0 ? void 0 : formValues.TextInput) == null || '' ? true : false
                                };
                            },
                            setFormState: function (formValues, currentValue) { return __awaiter(void 0, void 0, void 0, function () {
                                var _PreCheckRes, _PreCheckRes2, res, PreCheckRes, _res$data, _crud$PDICheckKeys$Co2, request, error_1, updatedPreDeliveryDetails;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, SearchPDICheckAPI({
                                                request: {
                                                    Key: formValues === null || formValues === void 0 ? void 0 : formValues.label,
                                                    Value: formValues === null || formValues === void 0 ? void 0 : formValues.TextInput,
                                                    OrganizationId: organizationId
                                                }
                                            })];
                                        case 1:
                                            res = _a.sent();
                                            PreCheckRes = null;
                                            if (!(res !== null && res !== void 0 && res.success)) return [3 /*break*/, 5];
                                            console.log('Response', formValues);
                                            request = {
                                                ProductId: res === null || res === void 0 || (_res$data = res.data) === null || _res$data === void 0 || (_res$data = _res$data.Chassis[0]) === null || _res$data === void 0 ? void 0 : _res$data.ProductId,
                                                CheckListId: (_crud$PDICheckKeys$Co2 = crud[PDICheckKeys === null || PDICheckKeys === void 0 ? void 0 : PDICheckKeys.ConfigurationPDICheck]) === null || _crud$PDICheckKeys$Co2 === void 0 || (_crud$PDICheckKeys$Co2 = _crud$PDICheckKeys$Co2.data) === null || _crud$PDICheckKeys$Co2 === void 0 || (_crud$PDICheckKeys$Co2 = _crud$PDICheckKeys$Co2.DynamicValues[0]) === null || _crud$PDICheckKeys$Co2 === void 0 ? void 0 : _crud$PDICheckKeys$Co2.ChecklistId
                                            };
                                            _a.label = 2;
                                        case 2:
                                            _a.trys.push([2, 4, , 5]);
                                            return [4 /*yield*/, dispatch(getListAPI({
                                                    key: PDICheckKeys === null || PDICheckKeys === void 0 ? void 0 : PDICheckKeys.InpectionQuestionPDICheck,
                                                    url: preCheckQuestionsUrl,
                                                    request: request
                                                }))];
                                        case 3:
                                            PreCheckRes = _a.sent();
                                            return [3 /*break*/, 5];
                                        case 4:
                                            error_1 = _a.sent();
                                            console.error('Failed to fetch PreCheck questions', error_1);
                                            return [3 /*break*/, 5];
                                        case 5:
                                            console.log('isAllowedToAddQuestion--77--', (_PreCheckRes = PreCheckRes) === null || _PreCheckRes === void 0 || (_PreCheckRes = _PreCheckRes.payload) === null || _PreCheckRes === void 0 || (_PreCheckRes = _PreCheckRes.value) === null || _PreCheckRes === void 0 ? void 0 : _PreCheckRes.data);
                                            updatedPreDeliveryDetails = (_PreCheckRes2 = PreCheckRes) === null || _PreCheckRes2 === void 0 || (_PreCheckRes2 = _PreCheckRes2.payload) === null || _PreCheckRes2 === void 0 || (_PreCheckRes2 = _PreCheckRes2.value) === null || _PreCheckRes2 === void 0 || (_PreCheckRes2 = _PreCheckRes2.data) === null || _PreCheckRes2 === void 0 ? void 0 : _PreCheckRes2.map(function (group) {
                                                var _ref;
                                                var isAllowedToAddQuestion = group === null || group === void 0 ? void 0 : group.IsAllowToAddCustomQuestion;
                                                return _objectSpread(_objectSpread({}, group), {}, {
                                                    // Questions: isAllowedToAddQuestion,
                                                    Questions: (_ref = (group === null || group === void 0 ? void 0 : group.Questions) || []) === null || _ref === void 0 ? void 0 : _ref.map(function (question) { return _objectSpread(_objectSpread({}, question), {}, {
                                                        IsAllowToAddCustomQuestion: isAllowedToAddQuestion
                                                    }); })
                                                });
                                            });
                                            console.log('updatedPreDeliveryDetails --', updatedPreDeliveryDetails);
                                            return [2 /*return*/, _objectSpread(_objectSpread(_objectSpread({}, formValues), res === null || res === void 0 ? void 0 : res.data), {}, {
                                                    searchSuccess: res !== null && res !== void 0 && res.success ? true : false,
                                                    PreDeliveryDetail: updatedPreDeliveryDetails
                                                    // addQuestion: updatedPreDeliveryDetails,
                                                })];
                                    }
                                });
                            }); }
                        }]
                }, !IS_MOBILE ? {
                    type: FormItemTypes.Box,
                    name: '',
                    justifyContent: 'end',
                    display: 'flex',
                    columnSize: 9,
                    gap: '12px',
                    elements: [{
                            type: FormItemTypes.Button,
                            name: '',
                            variant: 'text',
                            children: IS_DESKTOP ? 'Quick links' : '',
                            columnSize: 0,
                            sx: {
                                bgcolor: 'transparent',
                                fontWeight: 'medium',
                                fontSize: 'base'
                            },
                            startIcon: /*#__PURE__*/ React.createElement(LinkSvg, null),
                            setFieldProps: function (state) { return ({
                                type: FormItemTypes.Button,
                                disabled: state !== null && state !== void 0 && state.selectedVehicle ? false : true
                            }); }
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(Download, null),
                            columnSize: 0,
                            color: 'secondary',
                            variant: 'outlined',
                            sx: {
                                padding: '8px'
                            },
                            disabled: true
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(ShareIcon, {
                                height: 20,
                                width: 20,
                                color: "secondary"
                            }),
                            columnSize: 0,
                            color: 'secondary',
                            variant: 'outlined',
                            sx: {
                                padding: '8px'
                            },
                            disabled: true
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(PrintIconSVG, null),
                            columnSize: 0,
                            color: 'secondary',
                            variant: 'outlined',
                            sx: {
                                padding: '8px'
                            },
                            disabled: true
                        }, {
                            type: FormItemTypes.Divider,
                            name: '',
                            variant: 'fullWidth',
                            orientation: 'vertical',
                            columnSize: 0
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            variant: 'text',
                            children: 'Discard',
                            color: 'secondary',
                            columnSize: 0,
                            sx: {
                                fontSize: "base",
                                fontWeight: 'medium'
                            },
                            // disabled: true,
                            onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                var res;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, dispatch(showSurface({
                                                type: 'Dialog',
                                                Component: CSODiscard,
                                                containerProps: {
                                                    PaperProps: {
                                                        sx: {
                                                            width: '350px',
                                                            borderRadius: '8px'
                                                        }
                                                    }
                                                }
                                            }))];
                                        case 1:
                                            res = _a.sent();
                                            console.log('Discard--Res', res === null || res === void 0 ? void 0 : res.payload);
                                            if ((res === null || res === void 0 ? void 0 : res.payload) === 'discard') {
                                                navigate('/pdicheck');
                                            }
                                            return [2 /*return*/];
                                    }
                                });
                            }); }
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            variant: 'contained',
                            children: 'Save',
                            // disabled: isLoading,
                            loading: isLoading,
                            color: 'primary',
                            columnSize: 0,
                            setFieldProps: function (formValues, currValue) {
                                return {
                                    type: this.type,
                                    disabled: id ? false : formValues !== null && formValues !== void 0 && formValues.searchSuccess ? false : true
                                    // disabled:isLoading?isLoading: id ? false : formValues?.searchSuccess ? false : true
                                };
                            },
                            onClick: function () { return 'submit'; },
                            setFormState: function (formValues, currValue, field) { return __awaiter(void 0, void 0, void 0, function () {
                                var _formValues$PreDelive5, _formValues$Chassis, _crud$PDICheckKeys$Vi5, _formValues$Organizat, _roadTestData$current, _roadTestData$current2, allInspectionResults, isFailed, inspectionStatus_1, updatedQuestionGroups, chassis, upsertRequest;
                                return __generator(this, function (_a) {
                                    console.log('Form submitted with values:', formValues);
                                    if (formValues && formValues !== null && formValues !== void 0 && formValues.PreDeliveryDetail && Array.isArray(formValues === null || formValues === void 0 ? void 0 : formValues.PreDeliveryDetail)) {
                                        allInspectionResults = formValues.PreDeliveryDetail.flatMap(function (group) { return group.Questions.map(function (q) { return q.InspectionResult; }); });
                                        isFailed = allInspectionResults.includes(2);
                                        inspectionStatus_1 = isFailed ? 'Fail' : 'Pass';
                                        updatedQuestionGroups = formValues === null || formValues === void 0 || (_formValues$PreDelive5 = formValues.PreDeliveryDetail) === null || _formValues$PreDelive5 === void 0 ? void 0 : _formValues$PreDelive5.map(function (group) {
                                            var _group$Questions6;
                                            return _objectSpread(_objectSpread({}, group), {}, {
                                                Questions: (_group$Questions6 = group.Questions) === null || _group$Questions6 === void 0 ? void 0 : _group$Questions6.map(function (question) { return _objectSpread(_objectSpread({}, question), {}, {
                                                    CustomerQuestion: false
                                                }); })
                                            });
                                        });
                                        chassis = formValues === null || formValues === void 0 || (_formValues$Chassis = formValues.Chassis) === null || _formValues$Chassis === void 0 ? void 0 : _formValues$Chassis[0];
                                        upsertRequest = _objectSpread(_objectSpread({
                                            OdometerReading: Number(formValues === null || formValues === void 0 ? void 0 : formValues.OdometerReading)
                                        }, id ? {
                                            PreDeliveryCheckId: id
                                        } : {}), {}, {
                                            TechnicianId: formValues !== null && formValues !== void 0 && formValues.TechnicianId ? formValues === null || formValues === void 0 ? void 0 : formValues.TechnicianId : null,
                                            InspectorId: formValues !== null && formValues !== void 0 && formValues.InspectorId ? formValues === null || formValues === void 0 ? void 0 : formValues.InspectorId : null,
                                            ParentOrganizationId: parentOrganizationId,
                                            OrganizationId: UserOrganization,
                                            ProductId: id ? (_crud$PDICheckKeys$Vi5 = crud[PDICheckKeys === null || PDICheckKeys === void 0 ? void 0 : PDICheckKeys.ViewPDICheck]) === null || _crud$PDICheckKeys$Vi5 === void 0 || (_crud$PDICheckKeys$Vi5 = _crud$PDICheckKeys$Vi5.data) === null || _crud$PDICheckKeys$Vi5 === void 0 ? void 0 : _crud$PDICheckKeys$Vi5.ProductId : chassis === null || chassis === void 0 ? void 0 : chassis.ProductId,
                                            InstallbaseId: chassis === null || chassis === void 0 ? void 0 : chassis.InstallBaseTypeId,
                                            SupplierId: formValues === null || formValues === void 0 || (_formValues$Organizat = formValues.Organization) === null || _formValues$Organizat === void 0 ? void 0 : _formValues$Organizat.OrganizationId,
                                            SerialNo: chassis === null || chassis === void 0 ? void 0 : chassis.EngineNo,
                                            PinNo: chassis === null || chassis === void 0 ? void 0 : chassis.VinNo,
                                            Status: inspectionStatus_1,
                                            InspectionResult: inspectionStatus_1 === 'Pass' ? 1 : 2,
                                            DateOfMfg: chassis === null || chassis === void 0 ? void 0 : chassis.DateOfMfg,
                                            ModelName: chassis === null || chassis === void 0 ? void 0 : chassis.ProductName,
                                            Remarks: formValues === null || formValues === void 0 ? void 0 : formValues.Remarks,
                                            InspectionCriteria: formValues === null || formValues === void 0 ? void 0 : formValues.Remarks,
                                            QuestionName: formValues === null || formValues === void 0 ? void 0 : formValues.QuestionName,
                                            IsCustomQuestion: false,
                                            InitiatedById: IdentityId,
                                            RoadTest: {
                                                GeoCoordination: [{
                                                        lat: roadTestData === null || roadTestData === void 0 || (_roadTestData$current = roadTestData.currentPosition) === null || _roadTestData$current === void 0 ? void 0 : _roadTestData$current.lat,
                                                        lng: roadTestData === null || roadTestData === void 0 || (_roadTestData$current2 = roadTestData.currentPosition) === null || _roadTestData$current2 === void 0 ? void 0 : _roadTestData$current2.lng
                                                    }],
                                                StartDateTime: roadTestData === null || roadTestData === void 0 ? void 0 : roadTestData.StartDateTime,
                                                EndDateTime: roadTestData === null || roadTestData === void 0 ? void 0 : roadTestData.EndDateTime,
                                                // Remark: "Failed",
                                                Distance: roadTestData === null || roadTestData === void 0 ? void 0 : roadTestData.distance
                                            },
                                            PreDeliveryDetail: updatedQuestionGroups
                                        });
                                        return [2 /*return*/, {
                                                upsertRequest: upsertRequest
                                            }];
                                    }
                                    return [2 /*return*/];
                                });
                            }); }
                        }]
                } : null]
        }, {
            type: FormItemTypes.Stack,
            name: '',
            columnSize: 12,
            height: '212px',
            width: "100%",
            justifyContent: 'center',
            alignItems: 'center',
            setFieldProps: function (state) { return ({
                type: FormItemTypes.ContainerItem,
                sx: {
                    display: state !== null && state !== void 0 && state.resultnotfound ? undefined : 'none'
                },
                elements: [{
                        type: FormItemTypes.Stack,
                        name: '',
                        width: '270px',
                        gap: '16px',
                        justifyContent: 'center',
                        alignItems: 'center',
                        elements: [{
                                type: FormItemTypes.Button,
                                name: '',
                                color: 'secondary',
                                variant: 'outlined',
                                children: /*#__PURE__*/ React.createElement(Search, {
                                    color: "secondary"
                                }),
                                columnSize: 0
                            }, {
                                type: FormItemTypes.Stack,
                                name: '',
                                columnSize: 12,
                                gap: '4px',
                                elements: [{
                                        type: FormItemTypes.Typography,
                                        name: '',
                                        children: 'Result not found',
                                        fontSize: 'lg',
                                        fontWeight: 'strong',
                                        textAlign: 'center',
                                        columnSize: 12
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: '',
                                        children: "Your search \"".concat(state === null || state === void 0 ? void 0 : state.TextInput, "\" did not match any ").concat(state === null || state === void 0 ? void 0 : state.Key, ". Please try again."),
                                        columnSize: 12,
                                        color: 'secondary.500',
                                        textAlign: 'center'
                                    }]
                            }]
                    }]
            }); }
        }, {
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            spacing: 0,
            position: 'relative',
            setFieldProps: function (formValue) { return ({
                type: FormItemTypes.ContainerItem,
                sx: {
                    display: id ? undefined : formValue !== null && formValue !== void 0 && formValue.searchSuccess ? undefined : 'none'
                }
            }); },
            sx: {
                display: 'none'
            },
            elements: [{
                    type: FormItemTypes.Tabs,
                    name: 'Tabs',
                    columnSize: 12,
                    valueExpr: 'id',
                    displayExpr: 'Name',
                    onChange: function (e, value) {
                        if (!shouldShowQuestions && value === 'inspection') {
                            dispatch(showNotification({
                                isOpen: true,
                                message: "No inspection questions available for the selected VIN. Please check the PDI Checklist settings.",
                                type: "warning"
                            }));
                        }
                    },
                    panelGridProps: {
                        spacing: 2,
                        px: 3,
                        pb: {
                            xs: '50px'
                        }
                    },
                    // setFieldProps: (formValue) => (
                    //   console.log('State -- ', formValue),
                    //   {
                    //     type: FormItemTypes.Tabs,
                    //     sx: {
                    //       // display: searchValue ? undefined : 'none'
                    //       // display: formValue?.success === true ? undefined : 'none'
                    //     }
                    //   }),
                    tabs: [{
                            id: 'general',
                            Name: 'General',
                            elements: GENERAL_TAB
                        }, {
                            id: 'inspection',
                            Name: 'Inspection',
                            elements: INSPECTION
                        }, {
                            id: 'additional-info',
                            Name: 'Additional info',
                            elements: ADDITIONAL_INFO
                        }]
                }]
        }, IS_MOBILE ? {
            type: FormItemTypes.Box,
            name: '',
            display: 'flex',
            columnSize: 12,
            position: 'fixed',
            bottom: 0,
            right: 0,
            bgcolor: 'white',
            p: 2,
            width: '100%',
            justifyContent: 'space-between',
            sx: {
                borderTop: '1px solid ',
                borderColor: 'secondary.200',
                gap: '16px'
            },
            elements: [{
                    type: FormItemTypes.Button,
                    id: "createDocument",
                    name: '',
                    children: 'Discard ',
                    variant: 'text',
                    color: 'secondary',
                    columnSize: 0,
                    onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                        var res;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, dispatch(showSurface({
                                        type: 'Drawer',
                                        Component: CSODiscard,
                                        containerProps: {
                                            PaperProps: {
                                                sx: {
                                                    width: '100vw',
                                                    borderRadius: '8px 8px 0 0'
                                                }
                                            },
                                            anchor: 'bottom'
                                        }
                                    }))];
                                case 1:
                                    res = _a.sent();
                                    if ((res === null || res === void 0 ? void 0 : res.payload) === 'discard') {
                                        navigate('/pdicheck');
                                    }
                                    return [2 /*return*/];
                            }
                        });
                    }); }
                }, {
                    type: FormItemTypes.Button,
                    id: "createDocument",
                    name: '',
                    children: 'Save',
                    // disabled: isLoading,
                    // loading: isLoading,
                    variant: 'contained',
                    color: 'primary',
                    columnSize: 0,
                    setFieldProps: function (formValues, currValue) {
                        return {
                            type: this.type
                            // disabled: id ? false : formValues?.searchSuccess ? false : true
                            // disabled:isLoading?isLoading: id ? false : formValues?.searchSuccess ? false : true
                        };
                    },
                    onClick: function () { return 'submit'; },
                    setFormState: function (formValues, currValue, field) { return __awaiter(void 0, void 0, void 0, function () {
                        var _formValues$PreDelive6, _formValues$Chassis2, _crud$PDICheckKeys$Vi6, _formValues$Organizat2, _roadTestData$current3, _roadTestData$current4, allInspectionResults, isFailed, inspectionStatus_2, updatedQuestionGroups, chassis, upsertRequest;
                        return __generator(this, function (_a) {
                            console.log('Mobile View Question ---', formValues);
                            if (formValues.PreDeliveryDetail) {
                                allInspectionResults = formValues.PreDeliveryDetail.flatMap(function (group) { return group.Questions.map(function (q) { return q.InspectionResult; }); });
                                isFailed = allInspectionResults.includes(2);
                                inspectionStatus_2 = isFailed ? 'Fail' : 'Pass';
                                updatedQuestionGroups = formValues === null || formValues === void 0 || (_formValues$PreDelive6 = formValues.PreDeliveryDetail) === null || _formValues$PreDelive6 === void 0 ? void 0 : _formValues$PreDelive6.map(function (group) {
                                    var _group$Questions7;
                                    return _objectSpread(_objectSpread({}, group), {}, {
                                        Questions: (_group$Questions7 = group.Questions) === null || _group$Questions7 === void 0 ? void 0 : _group$Questions7.map(function (question) { return _objectSpread(_objectSpread({}, question), {}, {
                                            CustomerQuestion: false
                                        }); })
                                    });
                                });
                                chassis = formValues === null || formValues === void 0 || (_formValues$Chassis2 = formValues.Chassis) === null || _formValues$Chassis2 === void 0 ? void 0 : _formValues$Chassis2[0];
                                upsertRequest = _objectSpread(_objectSpread({
                                    OdometerReading: Number(formValues === null || formValues === void 0 ? void 0 : formValues.OdometerReading),
                                    TechnicianId: formValues !== null && formValues !== void 0 && formValues.TechnicianId ? formValues === null || formValues === void 0 ? void 0 : formValues.TechnicianId : null,
                                    InspectorId: formValues !== null && formValues !== void 0 && formValues.InspectorId ? formValues === null || formValues === void 0 ? void 0 : formValues.InspectorId : null
                                }, id ? {
                                    PreDeliveryCheckId: id
                                } : {}), {}, {
                                    ParentOrganizationId: parentOrganizationId,
                                    OrganizationId: UserOrganization,
                                    ProductId: id ? (_crud$PDICheckKeys$Vi6 = crud[PDICheckKeys === null || PDICheckKeys === void 0 ? void 0 : PDICheckKeys.ViewPDICheck]) === null || _crud$PDICheckKeys$Vi6 === void 0 || (_crud$PDICheckKeys$Vi6 = _crud$PDICheckKeys$Vi6.data) === null || _crud$PDICheckKeys$Vi6 === void 0 ? void 0 : _crud$PDICheckKeys$Vi6.ProductId : chassis === null || chassis === void 0 ? void 0 : chassis.ProductId,
                                    InstallbaseId: chassis === null || chassis === void 0 ? void 0 : chassis.InstallBaseTypeId,
                                    SupplierId: formValues === null || formValues === void 0 || (_formValues$Organizat2 = formValues.Organization) === null || _formValues$Organizat2 === void 0 ? void 0 : _formValues$Organizat2.OrganizationId,
                                    SerialNo: chassis === null || chassis === void 0 ? void 0 : chassis.EngineNo,
                                    PinNo: chassis === null || chassis === void 0 ? void 0 : chassis.VinNo,
                                    Status: inspectionStatus_2,
                                    InspectionResult: inspectionStatus_2 === 'Pass' ? 1 : 2,
                                    DateOfMfg: chassis === null || chassis === void 0 ? void 0 : chassis.DateOfMfg,
                                    ModelName: chassis === null || chassis === void 0 ? void 0 : chassis.ProductName,
                                    Remarks: formValues === null || formValues === void 0 ? void 0 : formValues.Remarks,
                                    InspectionCriteria: formValues === null || formValues === void 0 ? void 0 : formValues.Remarks,
                                    QuestionName: formValues === null || formValues === void 0 ? void 0 : formValues.QuestionName,
                                    IsCustomQuestion: false,
                                    InitiatedById: IdentityId,
                                    RoadTest: {
                                        GeoCoordination: [{
                                                lat: roadTestData === null || roadTestData === void 0 || (_roadTestData$current3 = roadTestData.currentPosition) === null || _roadTestData$current3 === void 0 ? void 0 : _roadTestData$current3.lat,
                                                lng: roadTestData === null || roadTestData === void 0 || (_roadTestData$current4 = roadTestData.currentPosition) === null || _roadTestData$current4 === void 0 ? void 0 : _roadTestData$current4.lng
                                            }],
                                        StartDateTime: roadTestData === null || roadTestData === void 0 ? void 0 : roadTestData.StartDateTime,
                                        EndDateTime: roadTestData === null || roadTestData === void 0 ? void 0 : roadTestData.EndDateTime,
                                        // Remark: "Failed",
                                        Distance: roadTestData === null || roadTestData === void 0 ? void 0 : roadTestData.distance
                                    },
                                    PreDeliveryDetail: updatedQuestionGroups
                                });
                                return [2 /*return*/, {
                                        upsertRequest: upsertRequest
                                    }];
                            }
                            return [2 /*return*/];
                        });
                    }); }
                }]
        } : null
    ];
    console.log('crud[PDICheckKeys?.SearchPDICheck]?.data', (_crud$PDICheckKeys$Se = crud[PDICheckKeys === null || PDICheckKeys === void 0 ? void 0 : PDICheckKeys.SearchPDICheck]) === null || _crud$PDICheckKeys$Se === void 0 ? void 0 : _crud$PDICheckKeys$Se.data);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        gridProps: {
            spacing: 0,
            bgcolor: 'secondary.50'
        },
        formData: formData
        // mode={id ? 'edit' : 'add'}
        ,
        mode: "edit",
        getKey: PDICheckKeys === null || PDICheckKeys === void 0 ? void 0 : PDICheckKeys.InpectionQuestionPDICheck,
        getFormAPI: getAllPDICheckAPI,
        getRequest: {
            ProductId: (_crud$PDICheckKeys$Se2 = crud[PDICheckKeys === null || PDICheckKeys === void 0 ? void 0 : PDICheckKeys.SearchPDICheck]) === null || _crud$PDICheckKeys$Se2 === void 0 || (_crud$PDICheckKeys$Se2 = _crud$PDICheckKeys$Se2.data) === null || _crud$PDICheckKeys$Se2 === void 0 || (_crud$PDICheckKeys$Se2 = _crud$PDICheckKeys$Se2.Chassis[0]) === null || _crud$PDICheckKeys$Se2 === void 0 ? void 0 : _crud$PDICheckKeys$Se2.ProductId,
            ///Search
            CheckListId: (_crud$PDICheckKeys$Co3 = crud[PDICheckKeys === null || PDICheckKeys === void 0 ? void 0 : PDICheckKeys.ConfigurationPDICheck]) === null || _crud$PDICheckKeys$Co3 === void 0 || (_crud$PDICheckKeys$Co3 = _crud$PDICheckKeys$Co3.data) === null || _crud$PDICheckKeys$Co3 === void 0 ? void 0 : _crud$PDICheckKeys$Co3.ChannelId,
            ///getByChannelID
            id: id,
            Mode: id ? 'Edit' : 'Add'
        }
        // updateFormAPI={PDICheckUpsertAPI}
        ,
        updateFormAPI: function (_ref2) { return __awaiter(void 0, void 0, void 0, function () {
            var _res$payload, request, data, attachments, payload, res, _res$payload2, data_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = _ref2.request;
                        data = request;
                        attachments = data === null || data === void 0 ? void 0 : data.Attachments;
                        payload = _objectSpread(_objectSpread({}, data === null || data === void 0 ? void 0 : data.upsertRequest), {}, {
                            Attachments: attachments
                        });
                        return [4 /*yield*/, dispatch(getListAPI({
                                key: PDICheckKeys === null || PDICheckKeys === void 0 ? void 0 : PDICheckKeys.UpsertPDICheck,
                                url: pdiCheckUpsertsUrl,
                                request: payload
                            }))];
                    case 1:
                        res = _a.sent();
                        console.log('res', res);
                        if (!(res !== null && res !== void 0 && (_res$payload = res.payload) !== null && _res$payload !== void 0 && (_res$payload = _res$payload.value) !== null && _res$payload !== void 0 && _res$payload.success)) return [3 /*break*/, 3];
                        dispatch(setReducerState({
                            key: getUpdateKey(PDICheckKeys === null || PDICheckKeys === void 0 ? void 0 : PDICheckKeys.Paging),
                            value: true
                        }));
                        return [4 /*yield*/, dispatch(showSurface({
                                type: 'Dialog',
                                Component: PDICheckSavedSuccessfullpopup,
                                containerProps: {
                                    PaperProps: {
                                        sx: {
                                            width: '400px',
                                            borderRadius: '8px'
                                        }
                                    }
                                },
                                componentProps: {
                                    data: res === null || res === void 0 || (_res$payload2 = res.payload) === null || _res$payload2 === void 0 || (_res$payload2 = _res$payload2.value) === null || _res$payload2 === void 0 ? void 0 : _res$payload2.data
                                }
                            }))];
                    case 2:
                        data_1 = _a.sent();
                        if ((data_1 === null || data_1 === void 0 ? void 0 : data_1.payload) === 'NAVIGATE_PDI_PAGE') {
                            navigate('/pdicheck');
                        }
                        _a.label = 3;
                    case 3: return [2 /*return*/, {
                            success: true
                        }];
                }
            });
        }); },
        updateKey: PDICheckKeys === null || PDICheckKeys === void 0 ? void 0 : PDICheckKeys.UpsertPDICheck
        // onClose={() => {
        //   dispatch(showSurface({
        //     type: 'Dialog',
        //     Component: PDICheckSavedSuccessfullpopup,
        //     containerProps: {
        //       PaperProps: { sx: { width: '400px', borderRadius: '8px' } },
        //     },
        //     componentProps: { data: crud[PDICheckKeys?.UpsertPDICheck]?.data },
        //   }));
        // }}
        ,
        onChange: function (e, _ref3) {
            var state = _ref3.state, field = _ref3.field, value = _ref3.value;
            if (field && e)
                dispatch(setReducerState({
                    key: getUpdateKey(PDICheckKeys === null || PDICheckKeys === void 0 ? void 0 : PDICheckKeys.SearchPDICheck),
                    value: true
                }));
        }
    }));
};
export default CreateNewPDICheck;
